<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center control-section">
					<ejs-dialog :buttons='alertDlgButtons' ref="alertDialog" v-bind:visible="false" :header='alertHeader' :animationSettings='animationSettings' :content='alertContent' :showCloseIcon='false' target='.control-section'
						width='550px' :isModal='true'>
					</ejs-dialog>
					<offer-request />
					<div class="h-3 grid justify-items-center">
						<div class="max-w-[1600px]">
							<ejs-progressbar v-if="loading" ref="indeterminate" id="successcontainer" type='Linear' isIndeterminate=true value=20></ejs-progressbar>
						</div>
					</div>
					<panel :title="$t('eny.applicant')" addclass="mt-4">
						<!-- Personal data -->
						<form id="base-condition-form">
							<div class="flex flex-col">
								<!-- Title personal information -->
								<div class="flex flex-col items-center mt-5 text-color-1">
									<div class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.personal_details')}}</p>
									</div>
								</div>
								<!-- Nationality -->
								<div class="flex flex-col items-center pt-0">
									<validation cssClass="w-full max-w-text">
										<ejs-dropdown id='nationality' name='nationality' :dataSource='nationalities' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.nationality')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.nationality"></ejs-dropdown>
									</validation>
								</div>
								<div class="flex flex-col items-center" v-show="request_loc.nationality && request_loc.nationality !== 'ch'">
									<!-- Residence permit -->
									<validation cssClass="w-full max-w-text">
										<ejs-dropdown id='residence_permit' name='residence_permit' :dataSource='residence_permits' :fields='fields' :enableMask="true" floatLabelType="Auto" :placeholder="$t('eny.residence_permit')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.residence_permit"></ejs-dropdown>
									</validation>
									<!-- Entry date -->
									<validation cssClass="w-full max-w-text">
										<ejs-datepicker id='entry_date' name='entry_date' floatLabelType="Auto" :placeholder="$t('eny.entry_date')" v-model:value="request_loc.entry_date" :format="$t('eny.date_format')" :open='onOpen'></ejs-datepicker>
									</validation>
								</div>
								<!-- DOB -->
								<div class="flex flex-col items-center">
									<validation cssClass="w-full max-w-text">
										<ejs-datepicker :change="this.triggerChangeValidate" @input="this.triggerInputValidate" ref="dob" id='dob' name='dob' floatLabelType="Auto" :placeholder="$t('eny.dob')" v-model:value="request_loc.dob" :format="$t('eny.date_format')" :open='onOpen'></ejs-datepicker>
									</validation>
								</div>
								<!-- Question pending enforcement -->
								<div class="flex flex-col items-center mt-0 text-color-1">
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.question_pending_enforcement')}}</p>
									</div>
								</div>
								<!-- Pending enforcement -->
								<div class="flex flex-col items-center pt-1">
									<validation cssClass="w-full max-w-text">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radiomale" name="pending_enforcement" value='1' v-model="request_loc.pending_enforcement" />
												<label for="radiomale"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radiofame" name="pending_enforcement" value='0' v-model="request_loc.pending_enforcement" />
												<label for="radiofame"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
								</div>
								<!-- Civil status label -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.civil_status')}}</p>
									</div>
								</div>
								<!-- Civil status -->
								<div class="flex flex-col items-center pt-5 form-group">
									<div class="w-full max-w-text flex flex-col">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio w-1/2">
												<input type="radio" id="radio_1" name="cust_civil_status" value='1' v-model="request_loc.civil_status" />
												<label for="radio_1"><span>{{$t('eny.married')}}</span></label>
											</div>
											<div class="eny-radio w-1/2">
												<input type="radio" id="radio_2" name="cust_civil_status" value='2' v-model="request_loc.civil_status" />
												<label for="radio_2"><span>{{$t('eny.divorced')}}</span></label>
											</div>
										</div>
										<div class='eny-radio-toolbar w-full pt-3'>
											<div class="eny-radio w-1/2">
												<input type="radio" id="radio_3" name="cust_civil_status" value='3' v-model="request_loc.civil_status" />
												<label for="radio_3"><span>{{$t('eny.registered')}}</span></label>
											</div>
											<div class="eny-radio w-1/2">
												<input type="radio" id="radio_4" name="cust_civil_status" value='4' v-model="request_loc.civil_status" />
												<label for="radio_4"><span>{{$t('eny.separated')}}</span></label>
											</div>
										</div>
										<div class='eny-radio-toolbar w-full pt-3'>
											<div class="eny-radio w-1/2">
												<input type="radio" id="radio_5" name="cust_civil_status" value='5' v-model="request_loc.civil_status" />
												<label for="radio_5"><span>{{$t('eny.single')}}</span></label>
											</div>
											<div class="eny-radio w-1/2">
												<input type="radio" id="radio_6" name="cust_civil_status" value='6' v-model="request_loc.civil_status" />
												<label for="radio_6"><span>{{$t('eny.widowed')}}</span></label>
											</div>
										</div>
									</div>
									<div class="error-element"></div>
								</div>
							</div>
						</form>
						<!-- Address -->
						<form id="cust-address-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Title address -->
									<div class="flex flex-col items-center mt-5 text-color-1">
										<div class="w-full max-w-text e-float-input">
											<p id="main_question" class="w-full text-center">{{$t('eny.address')}}</p>
										</div>
									</div>
									<!-- Customer street & nr -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_street" name="cust_street" floatLabelType="Auto" :placeholder="$t('eny.street_nr')" v-model:value="cur_address_loc.street"></ejs-maskedtextbox>
									</validation>
									<!-- Customer zip/city -->
									<div class="w-full max-w-text flex gap-2">
										<div class="w-1/3">
											<validation><ejs-maskedtextbox :change="handleChange" id="cust_zip" name="cust_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="cur_address_loc.zip"></ejs-maskedtextbox></validation>
										</div>
										<div class="w-2/3" v-if="this.multipleCity === true">
											<ejs-combobox id='cust_city' name='cust_city' :dataSource='this.cities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="cur_address_loc.city"></ejs-combobox>
										</div>
										<div class="w-2/3" v-else>
											<validation><ejs-maskedtextbox id="cust_city" name="cust_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="cur_address_loc.city"></ejs-maskedtextbox></validation>
										</div>
									</div>
									<!-- Customer address date -->
									<validation cssClass="w-full max-w-text">
										<ejs-datepicker id='cust_address_date' name='cust_address_date' floatLabelType="Auto" :placeholder="$t('eny.question_since_when')" v-model:value="request_loc.address_date" :format="$t('eny.date_format')" :open='onOpen'></ejs-datepicker>
									</validation>
								</div>
							</div>
						</form>
						<!-- Previous address -->
						<form v-show="showOldAddress" id="cust-prev-address-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Title address -->
									<div class="flex flex-col items-center mt-5 text-color-1">
										<div class="w-full max-w-text e-float-input">
											<p id="main_question" class="w-full text-center">{{$t('eny.prev_address')}}</p>
										</div>
									</div>
									<!-- Customer previous street & nr -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_prev_street" name="cust_prev_street" floatLabelType="Auto" :placeholder="$t('eny.street_nr')" v-model:value="old_address.street"></ejs-maskedtextbox>
									</validation>
									<!-- Customer previous zip/city -->
										<div class="w-full max-w-text flex gap-2">
										<div class="w-1/3">
											<validation><ejs-maskedtextbox :change="handleChange" id="cust_prev_zip" name="cust_prev_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="old_address.zip"></ejs-maskedtextbox></validation>
										</div>
										<div class="w-2/3" v-if="this.oldAddressMultipleCity === true">
											<ejs-combobox id='cust_prev_city' name='cust_prev_city' :dataSource='this.oldAddressCities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="old_address_loc.city"></ejs-combobox>
										</div>
										<div class="w-2/3" v-else>
											<validation><ejs-maskedtextbox id="cust_prev_city" name="cust_prev_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="old_address_loc.city"></ejs-maskedtextbox></validation>
										</div>
									</div>
								</div>
							</div>
						</form>
					</panel>
					<!-- Buttons -->
					<div v-if="allow_navigation" class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-2 sm:gap-6">
						<email-button />
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="prevStep">{{$t('eny.back')}}</button>
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="nextStep">{{$t('eny.forward')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { MaskedTextBoxComponent, FormValidator } from '@syncfusion/ej2-vue-inputs';
import { ComboBoxComponent, DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerComponent  } from "@syncfusion/ej2-vue-calendars";
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import { ProgressBarComponent }  from "@syncfusion/ej2-vue-progressbar";
import Panel from "../../Base/Panel.vue";
import SendEmailButton from "../../Base/SendEmailButton.vue";
import Validation from "../../Base/Validation.vue";
import OfferRequest from "./Request.vue";
import useNotification from "../../hooks/useNotification";
import useUtils from '../../hooks/useUtils';
import axios from "axios";

export default {
	name: "BaseConditions",
	components: {
		"ejs-maskedtextbox": MaskedTextBoxComponent,
		"ejs-combobox": ComboBoxComponent,
		"ejs-dropdown": DropDownListComponent,
		"ejs-datepicker": DatePickerComponent,
		'ejs-dialog': DialogComponent,
		'panel': Panel,
		'validation': Validation,
		'offer-request': OfferRequest,
		'email-button': SendEmailButton,
		'ejs-progressbar': ProgressBarComponent,
	},
	setup() {
		const { showNotification, hideNotification } = useNotification();
		const { sleep, sortList, isDateBefore, timeZoneOffsetOnInit, timeZoneOffsetOnSave, isFormattedDateValid, compareDates } = useUtils();
		return {
			showNotification,
			hideNotification,
			sleep,
			sortList,
			isDateBefore,
			timeZoneOffsetOnInit,
			timeZoneOffsetOnSave,
			isFormattedDateValid,
			compareDates
		}
	},
	data() {
		return {
			personalFormObject: {},
			request_loc: {},
			// controls' data
			nationalities: this.sortList(JSON.parse(this.$t('country.names')), 'value', 'label', null, JSON.parse(this.$t('country.priorityCountries'))),
			residence_permits: JSON.parse(this.$t('eny.residence_permits')),
			fields : { text: 'label', value: 'value' },
			// addresses
			addressFormValidator: {},
			prevAddressFormObject: {},
			cur_address_loc: {},
			old_address_loc: {},
			oldAddressMultipleCity: false,
			oldAddressCities: {},
			// dialog data
			alertHeader: this.$t('eny.we_re_sorry'),
			alertContent: '',
			animationSettings: { effect: 'None' },
			alertDlgButtons: [
				{ click: this.offerCloseDlgBtnClick, buttonModel: { content: this.$t('eny.end_application'), isPrimary: false } },
				{ click: this.correctDlgBtnClick, buttonModel: { content: this.$t('eny.correct'), isPrimary: true } }
			],
			cityFields: { text: 'City', value: 'City' },
			zipCodes: {},
			multipleCity: false,
			cities: {}
		};
	},
	mounted() {
		this.request_loc = this.request;
		this.cur_address_loc = this.cur_address ? this.cur_address : {};
		this.old_address_loc = this.old_address ? this.old_address : {};

		// personal data options
		const personalOptions = {
			rules: {
				nationality: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.nationality')})] },
				residence_permit: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.residence_permit')})] },
				entry_date: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.entry_date')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterDob, this.$t('eny.date_les_then_date', { date1: this.$t('eny.entry_date'), date2: this.$t('eny.dob') })]
				},
				dob: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.dob')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]
				},
				pending_enforcement: { required: [true, this.$t('eny.pending_enforcement_notempty_error_msg')] },
				cust_civil_status: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.civil_status')})] },
			},
			customPlacement: this.showValidationError,
		};
		this.personalFormObject = new FormValidator("#base-condition-form", personalOptions);
		// address options
		const addressFormOptions = {
			rules: {
				cust_street: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.street')})] },
				cust_city: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.city')})] },
				cust_zip: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.zip')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
				cust_address_date: {
					required: [true, this.$t('eny.address_date_notempty_error_msg')],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterDob, this.$t('eny.date_les_then_date', {date1: this.$t('eny.date'), date2: this.$t('eny.dob')})]
				},
			},
			customPlacement: this.showValidationError,
		};
		this.request_loc.dob = this.timeZoneOffsetOnInit(this.request_loc.dob)
		this.request_loc.entry_date = this.timeZoneOffsetOnInit(this.request_loc.entry_date)
		this.request_loc.address_date = this.timeZoneOffsetOnInit(this.request_loc.address_date)
		this.addressFormValidator = new FormValidator("#cust-address-form", addressFormOptions);
		// previous address options
		const prevAddressFormOptions = {
			rules: {
				cust_prev_street: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.street')})] },
				cust_prev_city: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.city')})] },
				cust_prev_zip: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.zip')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
			},
			customPlacement: this.showValidationError,
		};
		this.prevAddressFormObject = new FormValidator("#cust-prev-address-form", prevAddressFormOptions);

		this.getZipMap();

		this.$store.dispatch('customer/update_offer_step', 1);
	},
	methods: {
		triggerInputValidate() {
			this.personalFormObject.validate('entry_date')
			this.addressFormValidator.validate('cust_address_date')
		},
		triggerChangeValidate() {
			this.personalFormObject.validate('entry_date')
			this.addressFormValidator.validate('cust_address_date')
		},
		getZipMap() {
			axios.get('/customer/getZipMap')
				.then((response) => {
					this.zipCodes = response.data;
				})
		},
		isValidDate(input) {
			return this.isFormattedDateValid(input.value, this.$t('eny.moment_date_format'));
		},
		isAfterDob(input) {
			return this.compareDates(input.value, this.request_loc.dob, this.$t('eny.moment_date_format')) === 1;
		},
		prevStep: function() {
			this.$router.push('/offer/privacy_consent');
		},
		nextStep: function() {
			const validated = this.validate();
			const checked = this.checkConditions();
			if (validated && checked) {
				const requestCopy  = { ...this.request_loc };
				requestCopy.dob = this.timeZoneOffsetOnSave(this.request_loc.dob)
				requestCopy.entry_date = this.timeZoneOffsetOnSave(this.request_loc.entry_date)
				requestCopy.address_date = this.timeZoneOffsetOnSave(this.request_loc.address_date)
				this.$store.dispatch('customer/store_basecond', { request: requestCopy, cur_addr: this.cur_address_loc, old_addr: this.old_address_loc });
				this.$router.push('/offer/customer_income');
			}
		},
		validate: function() {
			let fieldsToCheck = ['nationality', 'dob', 'pending_enforcement'];
			if (this.request_loc.nationality && this.request_loc.nationality !== 'ch') {
				fieldsToCheck.push('residence_permit', 'entry_date');
			}
			let ok = true;
			fieldsToCheck.forEach(item => ok &= this.personalFormObject.validate(item))
			ok &= this.addressFormValidator.validate() && (!this.showOldAddress || this.prevAddressFormObject.validate());
			return ok;
		},
		onOpen: function(e) {
			this.sleep(10).then(function() {
				e.popup.offsetX = e.popup.relateTo.clientWidth - e.popup.properties.content.clientWidth;
			});
		},
		correctDlgBtnClick: function() {
			this.$refs.alertDialog.hide();
		},
		offerCloseDlgBtnClick: function() {
			this.$store.dispatch('customer/store_status', 3);
			this.$store.dispatch('customer/reset');
			this.$refs.alertDialog.hide();
			this.$router.push('/offer');
		},
		checkConditions: function() {
			const msgNoCredit = this.$t('eny.no_loan_msg') + "<br><br>";
			let ok = true;
			this.alertContent = "";
			// Check nationality.
			if (this.request_loc.nationality && this.request_loc.nationality !== "ch") {
				// For not Swiss citizens:
				// Check residence permit.
				const allowedPermits = ['b', 'c', 'g'];
				if (this.request_loc.residence_permit && !allowedPermits.includes(this.request_loc.residence_permit)) {
					this.alertContent = msgNoCredit + this.$t('eny.residence_permit_reason_msg');
				}
				// Check entry date.
				else if (this.request_loc.entry_date && this.isDateBefore(this.request_loc.entry_date, 12, 'months')) {
					this.alertContent = msgNoCredit + this.$t('eny.entry_date_reason_msg');
				}
				ok = this.alertContent.length == 0;
			}
			if (ok) {
				// Check pending_enforcement.
				if (this.request_loc.pending_enforcement == 1) {
					this.alertContent = msgNoCredit + this.$t('eny.pending_enforcement_reason_msg');
				}
				// Check dob.
				else if (this.request_loc.dob && this.isDateBefore(this.request_loc.dob, 18, 'years')) {
					this.alertContent = msgNoCredit + this.$t('eny.dob_reason_msg');
				}
			}
			ok = this.alertContent.length == 0;
			if (!ok) {
				this.$refs.alertDialog.show();
			}
			return ok;
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
		handleChange(e) {
			let cities = "";
			let model = "";
			let property = "";
			let isMultiple = "";
			switch (e.event.target.id) {
				case 'cust_zip': {
					cities = 'cities';
					model = 'cur_address_loc';
					property = 'city';
					isMultiple = 'multipleCity';
					break;
				}
				case 'cust_prev_zip': {
					cities = 'oldAddressCities';
					model = 'old_address_loc';
					property = 'city';
					isMultiple = 'oldAddressMultipleCity';
					break;
				}
			}
			if (e.value.length === 4) {
				if (this.zipCodes[e.value]) {
					if (this.zipCodes[e.value].length !== undefined) {
						this[isMultiple] = true;
						this[cities] = this.zipCodes[e.value];
						this[model][property] = this[cities][0].City;
					} else {
						this[isMultiple] = false;
						this[model][property] = this.zipCodes[e.value].City;
					}
				}
			} else {
				this[isMultiple] = false;
				this[model][property] = "";
			}
		},
	},
	computed: {
		...mapGetters('customer', ['request', 'cur_address', 'old_address', 'loading', 'success', 'message']),
		allow_navigation: function () {
			return this.request.id;
		},
		showOldAddress: function() {
			let result = false;
			if (this.request_loc.address_date && this.request_loc.address_date != "") {
				result = this.isDateBefore(this.request_loc.address_date, 12, 'months');
			}
			return result;
		}
	},
	watch: {
		message(value, oldValue) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
	}
}
</script>
<style>
/** Dialog definitions */
#app .e-dialog {
	@apply rounded-lg;
}
#app .e-dialog .e-dlg-header-content {
	@apply flex flex-col items-center;
}
#app .e-dialog .e-dlg-header-content .e-dlg-header {
	@apply text-center text-2xl font-bold;
}
#app .e-dialog .e-dlg-header-content {
	@apply bg-gray-100 rounded-b-none;
}
#app .e-dialog .e-dlg-content {
	@apply py-10;
}
#app .e-dialog .e-footer-content {
	@apply flex flex-row justify-between;
}
#app .e-dialog .e-footer-content {
	@apply bg-gray-100 rounded-t-none;
}
#app .e-dialog .e-footer-content button.e-btn {
	@apply text-center rounded-full text-white bg-color-2 hover:bg-color-2-hover focus:ring-4 focus:ring-blue-300 px-4 py-2 text-lg;
}
</style>
